

// export function isvalidUsername(str) {
//   const reg = /^[A-Za-z0-9]+$/
//   return reg.test(str)
// }

// /* 合法uri*/
// export function validateURL(textval) {
//   const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
//   return urlregex.test(textval)
// }

// /* 小写字母*/
// export function validateLowerCase(str) {
//   const reg = /^[a-z]+$/
//   return reg.test(str)
// }

// /* 大写字母*/
// export function validateUpperCase(str) {
//   const reg = /^[A-Z]+$/
//   return reg.test(str)
// }

// /* 大小写字母*/
// export function validatAlphabets(str) {
//   const reg = /^[A-Za-z]+$/
//   return reg.test(str)
// }xw

import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN';//引入中文文件

// // 配置中文
Validator.localize('zh_CN',zh_CN);

const config = {
  locale: 'zh_CN',
};

Vue.use(VeeValidate,config);

// 自定义validate 
// const dictionary = {
//    zh_CN: {
//       messages: {
//         email: () => '请输入正确的邮箱格式',
//         required: ( field )=> "请输入" + field
//       },
//       attributes:{
//         email:'邮箱',
//         password:'密码',
//         name: '账号',
//         phone: '手机'
//       }
//   }
// };

// Validator.updateDictionary(dictionary);

Validator.extend('mobile', {
  messages: {
    zh_CN:field => field + '必须是11位手机号码',
  },
  validate: value => {
    return value.length == 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
  }
});
Validator.localize('zh_CN',zh_CN);




// WEBPACK FOOTER //
// ./src/validate/validate.js